import React, { Component } from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { AppConsumer } from "../../context/context"
import { isBrowser } from "../../services/firebase"

export class MobileLoginButton extends Component {
  render() {
    return (
      <AppConsumer>
        {value => {
          if (isBrowser) {
            const { isAuthenticated, unreadAlerts } = value
            if (isAuthenticated) {
              if (unreadAlerts && unreadAlerts > 0) {
                return (
                  <Link to={"/app/notifications"} className="button is-small">
                    <span className="icon has-text-link">
                      <FontAwesomeIcon icon="bell" />
                    </span>
                    <span>{unreadAlerts}</span>
                  </Link>
                )
              } else {
                return null
              }
            } else {
              return (
                <div className="buttons">
                  <Link
                    to="/app/signup"
                    state={{
                      signupPayload: null,
                    }}
                    className="button is-small is-link"
                  >
                    Sign Up
                  </Link>
                </div>
              )
            }
          } else {
            return null
          }
        }}
      </AppConsumer>
    )
  }
}

export default MobileLoginButton
